import type { Component } from 'solid-js'
import { createSignal, Show } from 'solid-js'
import { Icon } from '@iconify-icon/solid'
import axios from '../../shared/services/axios.interceptor'
import { ApiEndpoint } from '../../shared/api-endpoint'
import { downloadCSV } from '../../shared/helpers/download-csv'
import { useTransContext } from '@mbarzda/solid-i18next'

interface ExportCsvButtonProps {
  buildParams: () => URLSearchParams | null
}

const ExportCsvButton: Component<ExportCsvButtonProps> = (props) => {
  const [t] = useTransContext()
  const [isExporting, setIsExporting] = createSignal(false)
  const [exportError, setExportError] = createSignal(false)

  const handleExport = async () => {
    const params = props.buildParams()
    if (!params || isExporting()) return

    setIsExporting(true)
    setExportError(false)
    try {
      const url = `${import.meta.env.VITE_API_URL}/${ApiEndpoint.SubscriberExport}?${params.toString()}`
      const response = await axios.get<string>(url, { responseType: 'text' as const })
      downloadCSV(response.data, 'subscribers.csv')
    } catch (err) {
      console.error('Export failed:', err)
      setExportError(true)
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <div class="relative">
      <button
        type="button"
        onClick={handleExport}
        disabled={isExporting()}
        class="flex h-9 w-9 items-center justify-center rounded-full bg-primary-600 text-white shadow-sm transition-colors hover:bg-primary-700 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <Show
          when={!isExporting()}
          fallback={
            <div
              class="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"
              aria-hidden="true"
            />
          }
        >
          <Icon icon="heroicons:arrow-down-tray" class="text-[1rem]" />
        </Show>
      </button>
      <Show when={exportError()}>
        <p class="absolute right-0 top-full mt-1 whitespace-nowrap text-sm text-red-600">
          {t('ls_user_directory_export_error')}
        </p>
      </Show>
    </div>
  )
}

export default ExportCsvButton
